import getQueryString from 'Common/getQueryString';
import isBodyStyle from 'Common/isBodyStyle';
import * as R from 'ramda';
import { readCookie } from 'utils/cookies';
import { transformMake, transformModel } from './mapping';

export default (make, urlModel, ui, search, dealerId, currentUrl) => {
  const urlMake = !isBodyStyle(make) ? make : undefined;
  const urlBodystyle = isBodyStyle(make) ? make : undefined;
  let urlSearchValues = {};

  if (urlMake) {
    urlSearchValues.urlmake = `{"key":"${transformMake(urlMake)}"}`;
  }

  if (urlModel) {
    urlSearchValues.urlmodel = `{"key":"${transformModel(urlModel)}"}`;
  }

  if (urlBodystyle) {
    urlSearchValues.urlcarType = `{"key":"${urlBodystyle}"}`;
  }

  if (dealerId) {
    urlSearchValues.dealerId = `{"key":"${dealerId}"}`;
  }

  let qs = search.substr(1);
  let postCodeQuery = '';
  let isPostCode = false;
  if (R.contains('postcode=', qs)) {
    if (!ui.postCode) {
      ui.postCode = {};
    }
    ui.postCode.isValid = true;
    isPostCode = true;
  } else {
    const lastPostCode = readCookie('lastPostCode');
    postCodeQuery = lastPostCode ? `postcode=${lastPostCode}` : '';
    isPostCode = !!lastPostCode || false;
  }

  const queryFormUrl = getQueryString({ values: urlSearchValues });
  // If no postcode , remove the sort by distance
  if (R.contains('sort=distance', qs) && !isPostCode) {
    qs = qs.replace(/sort=distance/g, '');
  }

  const connector = element => {
    return !element ? '' : '&';
  };

  const query = queryFormUrl
    ? `${queryFormUrl}${connector(qs)}${qs}` +
      `${connector(postCodeQuery)}${postCodeQuery}` +
      `&currentUrl=${currentUrl}`
    : `${connector(qs)}${qs}` +
      `${connector(postCodeQuery)}${postCodeQuery}` +
      `&currentUrl=${currentUrl}`;
  return query;
};



// WEBPACK FOOTER //
// ./src/Results/buildQuery/index.js